import { useRef, useEffect } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

export function OutsideClickHandler({ children, onOutsideClick, ignoreRef }) {
  const wrapperRef = useRef(null)

  const handleClickOutside = event => {
    if (
      wrapperRef.current &&
      document.body.contains(event.target) &&
      !wrapperRef.current.contains(event.target) &&
      event.target !== _.get(ignoreRef, "current")
    ) {
      onOutsideClick()
    } else if (event.target === _.get(ignoreRef, "current")) {
      event.preventDefault()
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside, false)
    document.addEventListener("focus", handleClickOutside, true)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside, false)
      document.removeEventListener("focus", handleClickOutside, true)
    }
  })

  return <div ref={wrapperRef}>{children}</div>
}

OutsideClickHandler.propTypes = {
  children: PropTypes.node.isRequired,
  ignoreRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }),
  onOutsideClick: PropTypes.func.isRequired
}

export default OutsideClickHandler
